
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"92.433","height":"92.425"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M30.827 84.035l1.57-.91 3.47-2 26.5-15.3 6.92-3.99 18.15-10.48a10 10 0 000-17.32l-1.58-.91-3.46-2-26.5-15.3-6.93-4-18.14-10.47a10 10 0 00-15 8.66v65.36a10.007 10.007 0 0015 8.66z","data-name":"Pfad 14216","fill":"#f5f5f5"}}),_c('path',{attrs:{"d":"M1.627 29.825l14.2 24.59v-7.99l-10.74-18.6a8 8 0 016.93-12h65.36a8 8 0 016.93 12l-1.91 3.3-20.03 34.7-10.74 18.6a8 8 0 01-13.86 0l-1.9-3.3-3.46 2 1.9 3.3a12 12 0 0020.78 0l14.2-24.59 16.57-28.71 1.91-3.3a12 12 0 00-10.39-18h-65.36a12 12 0 00-10.39 18z","data-name":"Pfad 14217","opacity":".15","fill":"#1b5be9"}}),_c('g',[_c('path',{attrs:{"d":"M27 26h40v40H27z","fill":"none"}}),_c('g',{attrs:{"data-name":"Gruppe 27712"}},[_c('path',{staticClass:"cls-4",attrs:{"d":"M50.179 47.739a10.722 10.722 0 00-16.517 9.024.977.977 0 00.978.978h11.7a.978.978 0 100-1.955H35.681a8.765 8.765 0 0113.44-6.4.977.977 0 001.057-1.644z","data-name":"Pfad 14185"}}),_c('path',{staticClass:"cls-4",attrs:{"d":"M44.389 45.144a6.238 6.238 0 10-6.239-6.239 6.246 6.246 0 006.239 6.239zm0-10.522a4.283 4.283 0 11-4.283 4.28 4.289 4.289 0 014.283-4.28z","data-name":"Pfad 14186"}})]),_c('path',{staticClass:"cls-4",attrs:{"d":"M54.27 60.267a.969.969 0 01-.967-.969v-4.131h-4.131a.968.968 0 010-1.935h4.131v-4.127a.968.968 0 011.935 0v4.13h4.131a.968.968 0 010 1.935h-4.131v4.131a.969.969 0 01-.968.966z","data-name":"Pfad 14187"}})])])
          )
        }
      }
    